import { DataNotFoundImage, LinkArrowIcon } from 'assets'
import { CustomModal } from 'components'
import { contentAnalysisType, contentAnalysisTypeName } from 'constant/const'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
   getVideoContentAction,
   setVideoContentType,
   setVideoRiskScore
} from 'store/action/videoReducer'

function VideoContentModal({ videoContentModal, onClose }) {
   const videoRedux = useSelector((state) => state.videoRedux)
   const { videoContentLoading, videoDetails, videoContent, videoContentType, videoRiskScore } =
      videoRedux
   const dispatch = useDispatch()
   const settingData = useSelector((state) => state.settings)
   const { selectedChannelID } = settingData
   const [riskScore, setRiskScore] = useState(0)
   const [modalTitle, setModalTitle] = useState('')

   useEffect(() => {
      switch (videoContentType) {
         case contentAnalysisType.brandsafety:
            setModalTitle('Risk Analysis')
            break
         case contentAnalysisType.brandmentions:
            setModalTitle('Brand and Notable mentions')
            break
         case contentAnalysisType.badwords:
            setModalTitle('Language Advisory')
            break
         case contentAnalysisType.neginfluence:
            setModalTitle('Content Advisory')
            break

         default:
            break
      }

      return () => {}
   }, [videoContentType])

   useEffect(() => {
      if (videoDetails && videoContent === null && !videoContentLoading) {
         dispatch(
            getVideoContentAction({
               channel_id: selectedChannelID,
               video_id: videoDetails?.video_id,
               content_param: contentAnalysisType.brandsafety
            })
         )
         dispatch(setVideoContentType(contentAnalysisType.brandsafety))
      }
      return () => {}
   }, [videoDetails])

   useEffect(() => {
      if (videoContentType === contentAnalysisType.brandsafety && videoContent) {
         setRiskScore(videoContent?.risk_score || 0)
         dispatch(setVideoRiskScore(videoContent?.risk_score || 0))
      }
      return () => {}
   }, [videoContent, videoContentType])

   const onChangeAnalysis = (type) => {
      dispatch(
         getVideoContentAction({
            channel_id: selectedChannelID,
            video_id: videoDetails?.video_id,
            content_param: type
         })
      )
      dispatch(setVideoContentType(type))
   }

   return (
      <div>
         <CustomModal
            show={videoContentModal}
            title={modalTitle || 'Risk Analysis'}
            closeModal={onClose}
            centered
            size="lg"
            scrollable
            subTitle={`Risk Score: ${videoRiskScore || 0}`}
            footerComponent={
               <>
                  <div className="video-content-btn atenya-ai-btn-group mt-3">
                     <button
                        disabled={videoContentLoading}
                        className={`atenya-ai-btn ${
                           videoContentType === contentAnalysisType.brandsafety ? 'active' : ''
                        }`}
                        onClick={() => {
                           onChangeAnalysis(contentAnalysisType.brandsafety)
                        }}>
                        <span className="content-text"> Risk Analysis</span>
                        <div className="at-icon">
                           <LinkArrowIcon />
                        </div>
                     </button>
                     <button
                        disabled={videoContentLoading}
                        className={`atenya-ai-btn ${
                           videoContentType === contentAnalysisType.brandmentions ? 'active' : ''
                        }`}
                        onClick={() => {
                           onChangeAnalysis(contentAnalysisType.brandmentions)
                        }}>
                        <span className="content-text">Brand and Notable Mentions</span>
                        <div className="at-icon">
                           <LinkArrowIcon />
                        </div>
                     </button>

                     <button
                        disabled={videoContentLoading}
                        className={`atenya-ai-btn ${
                           videoContentType === contentAnalysisType.neginfluence ? 'active' : ''
                        }`}
                        onClick={() => {
                           onChangeAnalysis(contentAnalysisType.neginfluence)
                        }}>
                        <span className="content-text">Content Advisory</span>
                        <div className="at-icon">
                           <LinkArrowIcon />
                        </div>
                     </button>
                     <button
                        disabled={videoContentLoading}
                        className={`atenya-ai-btn ${
                           videoContentType === contentAnalysisType.badwords ? 'active' : ''
                        }`}
                        onClick={() => {
                           onChangeAnalysis(contentAnalysisType.badwords)
                        }}>
                        <span className="content-text">Language Advisory</span>
                        <div className="at-icon">
                           <LinkArrowIcon />
                        </div>
                     </button>
                  </div>
               </>
            }>
            <></>
            <div className="video-content-section">
               {videoContentLoading ? (
                  <div className="card_sk">
                     <div className="card__title loading"></div>
                     <div className="card__title loading"></div>
                     <div className="card__title loading"></div>
                  </div>
               ) : !videoContent?.text || Object.keys(videoContent?.text).length === 0 ? (
                  <div className="not-found-section">
                     <img
                        src={DataNotFoundImage}
                        alt="DataNotFoundImageF"
                        className="not-found-image"
                     />
                     <p>Oops!, {modalTitle} not found </p>
                  </div>
               ) : videoContentType === contentAnalysisType.brandmentions ? (
                  videoContent?.text &&
                  Object.entries(videoContent?.text).map(([key, value]) => {
                     return (
                        <div className="at-text-light mt-2" key={key}>
                           <label className="at-text-dark">{key}</label> <p>{value}</p>
                        </div>
                     )
                  })
               ) : (
                  videoContent?.text?.split('\n').map((line, index) => (
                     <React.Fragment key={index}>
                        <div
                           className="at-text-light mb-2"
                           dangerouslySetInnerHTML={{ __html: line }}
                        />
                        {/* <br /> */}
                     </React.Fragment>
                  ))
               )}
            </div>
         </CustomModal>
      </div>
   )
}

export default VideoContentModal
